import { inject, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountManagementComponent } from './account-management.component';
import { MainLayoutComponent } from '../../layouts/main-layout/main-layout.component';
import { CanDeactivateComponent } from 'src/app/shared/interfaces/can-deactivate-component';
import { CanDeactivateGuard } from 'src/app/shared/services/can-deactivate.guards';

const routes: Routes = [
    {
        path: '',
        component: AccountManagementComponent,        
        canDeactivate: [(component: CanDeactivateComponent) => inject(CanDeactivateGuard).canDeactivate(component)],
    }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AccountManagementRoutingModule { }
